const APP_PAGES = ['omni-home', 'x4u']

export { APP_PAGES }
